module.exports = __webpack_public_path__ + "img/62.222ae749.svg";